import css from 'styled-jsx/css';
import { isRTL } from 'common/styling/theme';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/screen-size';
  @import 'src/common/styling/_mixins-scss/rem';

  :global(.react-phone-number-input__country) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50px;
  }

  .react-phone-number-input__input {
    padding-top: rem(15px);
    padding-left: rem(15px);
  }

  .react-phone-number-input__icon {
    width: 19px;
    height: 14px;
  }

  .react-phone-number-input__icon--international {
    border: none !important;
    width: 16px;
    height: 16px;
  }

  @supports (-webkit-marquee-repetition: infinite) and (object-fit: fill) {
    .react-phone-number-input__icon--international {
      width: 15px;
    }
  }

  .react-phone-number-input__icon-image {
    width: 100%;
    height: 100%;
  }

  .PhoneFormField {
    position: relative;
    margin-bottom: 10px;
    input {
      min-height: rem(54px);
      position: relative;
      z-index: 4;
    }
  }

  .PhoneFormField__label {
    display: inline-block;
    position: absolute;
    top: calc(37% + 1px);
    transform: translateY(-50%);
    left: ${isRTL ? 'auto' : '75px'};
    right: ${isRTL ? '75px' : 'auto'};
    transition: all 0.25s ease;
    cursor: text;

    &.haveText {
      top: 6px;
      font-size: rem(12px);
      transform: translateY(0);
      z-index: 4;
    }

    &.active {
      top: 6px;
      font-size: rem(12px);
      transform: translateY(0);
      z-index: 4;
    }
  }

  .PhoneFormField__error {
    width: 100%;
    display: inline-block;
    min-height: 15px;
  }

  .PhoneFormField {
    input:disabled {
      opacity: 1 !important;
    }
    input:disabled + label {
      cursor: default !important;
      opacity: 1 !important;
    }
    &__disabled {
      .PhoneFormField__label {
        z-index: 5;
        cursor: default;
      }
    }
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    .PhoneFormField__label {
      transition: none;
    }
  }

  @supports (-ms-ime-align: auto) {
    .PhoneFormField__label {
      transition: none;
    }
  }
`;

const getDynamicStyles = ({ colors, border }) => {
  return css.global`
    .react-phone-number-input__country .rrui__select__autocomplete {
      ::placeholder {
        color: ${colors.white.hex} !important;
      }
    }

    .react-phone-number-input__country,
    .react-phone-number-input__input {
      border: 1px solid ${colors.lightGray.hex};
      border-radius: ${border.radius};
      &:focus {
        border-color: ${colors.primary.hex};
      }
    }

    .react-phone-number-input__country-select {
      &:focus {
        .rrui__select__arrow {
          &:after {
            border-color: ${colors.primary.hex};
          }
        }
      }
    }

    .react-phone-number-input__icon {
      border: 1px solid ${colors.lightGray.hex};
    }

    .PhoneFormField {
      input:focus {
        border-color: ${colors.primary.hex};
      }
      &.error {
        input,
        input:focus,
        .rrui__select__button,
        .rrui__select__arrow:after {
          border-color: ${colors.error.hex};
        }
        label,
        .rrui__select__arrow {
          color: ${colors.error.hex};
        }
        :global(svg) {
          fill: ${colors.error.hex};
        }
      }
      input:disabled {
        background: ${colors.disabled.hex};
        color: ${colors.disabled.hex};
        -webkit-text-fill-color: ${colors.black.hex};
        &.rrui__input-element {
          color: ${colors.black.hex};
          -webkit-text-fill-color: ${colors.black.hex};
        }
      }
    }

    .PhoneFormField__label {
      color: ${colors.gray.hex};
      &.haveText {
        color: ${colors.gray.hex};
      }
      &.active {
        color: ${colors.primary.hex};
      }
    }

    .PhoneFormField__error {
      color: ${colors.error.hex};
    }
  `;
};

export { staticStyles, getDynamicStyles };
